import IProductVariation from "@/interfaces/variation.interface";
import { VariationFilterMessages } from "@/messages/variation/variations-filter.messages";
import { VariationsTableMessages } from "@/messages/variation/variations-table.messages";
import { FilterAttributes, FilterType, FilterValue, IFilter } from "@/types/filter.types";
import { SelectData } from "@/types/form.types";

import { VariationFilterKey } from "./types";

export const VARIATIONS_TABLE_COLUMNS = (messages: VariationsTableMessages) => [
  messages.descriptionColumn,
  messages.optionsColumn,
];

export const VARIATION_FILTER_OPTIONS = (
  messages: VariationFilterMessages
): SelectData<VariationFilterKey>[] => [
  { label: messages.allOption, value: "all" },
  { label: messages.descriptionOption, value: "description" },
];

export const VARIATION_FILTER_ATTRIBUTES: Partial<Record<VariationFilterKey, FilterAttributes>> = {
  all: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "disable",
  },
  description: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
};

export const VARIATION_FILTER_OPTION_VALUES = (): Partial<
  Record<VariationFilterKey, SelectData<FilterValue>[]>
> => ({
  description: [],
});

export const initialVariationFilterValues: IFilter<IProductVariation>[] = [
  {
    property: "description",
    value: "",
    filterType: FilterType.Contains,
  },
];
